import { getField, updateField } from 'vuex-map-fields';
import StorageService from '@/services/StorageService';
import CoursesService from '@/services/CoursesService';

const getDefaultState = function () {
    return {
        id: null,
        name: null,
        description: null,
        sortOrder: null,
        status: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        name: state.name,
        description: state.description,
        sortOrder: state.sortOrder,
        status: state.status
    }),
};

const mutations = {
    setLecturesRegion(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadLecturesRegion({ commit }, data) {
        const course = StorageService.getCourse();
        const res = await CoursesService.getCourseRegions(course.id, {
            EntityId: data.id
        });
        commit('setLecturesRegion', res.data.items[0]);
        return res.data;
    },
    async loadLecturesRegionAdmin({ commit }, data) {
        const res = await CoursesService.getReportAdmin(data.id);
        commit('setLecturesRegion', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
